import { TokenService } from '../services/token.service';
import { HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError, NEVER } from 'rxjs';
import { UtilityService } from '@app/common/utility.service';

let isVisibleMessage = false;
const msgList: string[] = ['Browser session expired','Could not find userid from token','Could not find browser sessionid'];

const callEventFromParentLego = () => {
  isVisibleMessage = true;  
  const eventData = { 
    isSessionExpired: true,
  };
  (window as any)._sessionExpiredData = eventData;
  const sessionExpiredEvent = new CustomEvent('session_expired', {
    bubbles: true,
    composed: true,
    detail: eventData
  });
  window.dispatchEvent(sessionExpiredEvent); 
};

const callInvalidBrowserSessionEventFromParentLego = () => {
  isVisibleMessage = true;  
  const eventData = { 
    isInvalidBrowserSession: true,
  };
  (window as any)._invalidBrowserSessionData = eventData;
  const invalidBrowserSessionEvent = new CustomEvent('invalid_browser_session', {
    bubbles: true,
    composed: true,
    detail: eventData
  });
  window.dispatchEvent(invalidBrowserSessionEvent); 
};

export const tokenInterceptor = (request: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const router = inject(Router);
  const tokenService = inject(TokenService);
  const utilityService = inject(UtilityService);
  
  const addToken = (request: HttpRequest<any>) => {
    const token = tokenService.getToken();
    const sessionId = tokenService?.getBrowserSessionId();
    
    // Only add headers if we have a valid token
    if (token && token !== 'null' && token !== 'undefined') {
      return request.clone({
        setHeaders: {        
          Authorization: `Bearer ${token}`,
          __browsersessionid: sessionId || '',
          'X-Requested-With': 'XMLHttpRequest',
          'Cache-Control':'no-cache, no-store, must-revalidate, post-check=0, pre-check=0, max-age=0, s-maxage=0'
        }
      });
    }
    return request;
  }
  
  request = addToken(request);
  return next(request).pipe(
    catchError((error:HttpErrorResponse) => {
      if (utilityService.getSessionFlag('browserSessionId') == null || utilityService.getSessionFlag('browserSessionId') === undefined) {
        if (!isVisibleMessage) {
          utilityService.setSessionLogoutContext('invalid_session');
          callInvalidBrowserSessionEventFromParentLego();
          setTimeout(() => {
                utilityService.logoutFromSystem();
                router.navigate(['/']);
            }, 100);
        }
        return NEVER;
      }
      else if (error.status === 401 && typeof error.error === 'string' && msgList.some(msg => error.error.includes(msg))) {
        if (!isVisibleMessage) {
            utilityService.setSessionLogoutContext('invalid_session');
            callEventFromParentLego();
            utilityService.removeSessionFlag('browserSessionId');
            setTimeout(() => {
               utilityService.logoutFromSystem();
                router.navigate(['/']);
            }, 100);
        }
        return NEVER;
      }   
      else if (error.status === 401) {
              if (error.error && typeof error.error === 'string' && (error.error.indexOf('Forbidden: Access denied.') != -1)) {
                router.navigate(['/release/insufficient-permission']);
              } else {
                utilityService.logoutFromSystem();
                router.navigate(['/']);
              }
            }
      return throwError(() => error);
    })
  );
};
